<div class="row" *ngIf="showError">
	<div class="col-md-12 panel panel-default">
		<div class="panel-body">
			<div class="padding-8">
				<h4 style="color: red">Device is either not fount, deleted or you don't have access to use it.</h4>
			</div>
		</div>
	</div>
</div>